export default __webpack_public_path__ + "static/media/four-sample.044cb1f2.svg";